import { pxToRem } from '../utils/font';

const preSpace = {
  0: 0,
  0.5: pxToRem(4),
  1: pxToRem(8),
  1.5: pxToRem(12),
  2: pxToRem(16),
  2.5: pxToRem(20),
  3: pxToRem(24),
  4: pxToRem(32),
  5: pxToRem(40),
  6: pxToRem(48),
  7: pxToRem(56),
  8: pxToRem(64),
  9: pxToRem(72),
  10: pxToRem(80),
  11: pxToRem(88),
  12: pxToRem(96),
  13: pxToRem(104),
  14: pxToRem(112),
  15: pxToRem(120),
};

export type Spacing = keyof typeof preSpace | 'auto' | string;

export const space = preSpace as Record<Spacing, string | number>;
